import React from "react";
import { observer } from "mobx-react";
import { settingsStoreData } from "Stores/settingsData";
import NewTooltip from "Components/common/NewTooltip";

// Shown on a CRM settings page opened from an export that had no outbound field mapping (?source=contact)
const CrmExportActionRequired = observer(
  ({ crmName = "", isConnected = false }) => {
    if (!settingsStoreData?.fromContacts) {
      return null;
    }
    return (
      <>
        <NewTooltip
          className={isConnected ? "crmConnected" : "crmNotConnected"}
          closeIconCbk={() => settingsStoreData.setFromContacts(false)}
          heading="Action Required"
          text={
            isConnected
              ? `Set field sync direction to ‘Outbound’ or ‘2-Way Sync’ for fields you want to export to ${crmName}`
              : `Click to connect your ${crmName} CRM and start syncing contacts.`
          }
        />
        <div
          className="highlightContactExportOverlay"
          onClick={() => settingsStoreData.setFromContacts(false)}
        />
      </>
    );
  }
);

export default CrmExportActionRequired;
